import { ui as types } from '@codesass/types';

const config: types.Config = {
  sidebar: [
    {
      path: 'admin/*',
      enableLeft: true,
      isLeftShown: true,
    },
  ],
  footer: [
    {
      path: 'admin/*',
      shown: false,
    },
  ],
};

export default config;
